import { gql } from "@apollo/client";

export const DELETE_VISITAS_CERO = gql`
mutation deleteVisitasCero($idEvaluacion: Int!, $idProfesional: Int!, $idTipoProfesional: Int!, $idFiguraProfesional: Int!, $idFrecuencia: Int!) {
    deleteVisitasCero(idEvaluacion: $idEvaluacion, idProfesional: $idProfesional, idTipoProfesional: $idTipoProfesional, idFiguraProfesional: $idFiguraProfesional, idFrecuencia: $idFrecuencia)
}`;